import React, { useState } from 'react';
import moment from 'moment';
import { useForm, useFetch } from '../../../../hooks'
import { FormHeader, FormFooter, FormBody, Form } from '../../../../modules/Form/styled';
import Buttons from '../../../../modules/Buttons';
import Button from '../../../../components/inputs/Button';
import DatePicker from '../../../../components/DatePicker';
import TextArea from '../../../../components/inputs/TextArea';
import Checkbox from '../../../../components/inputs/Checkbox';

const FormAddEventRemind = ({ endpoint, onClickCancel, onClickAdd }) => {
    const [date, setDate] = useState(moment()._d);

    //TODO add fetching
    const { doFetch } = useFetch({
        url: endpoint,
        method: 'POST'
    })

    const addEvent = async values => {
        await doFetch({
            data: {
                ...values,
                date
            }
        })
        onClickAdd();
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: addEvent
    })

    const handleChangeDate = date => {
        setDate(date);
    };

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader alignLeft small>
                Przypomnij
            </FormHeader>
            <FormBody minHeight={false}>
                <DatePicker
                    selected={date}
                    onChange={handleChangeDate}
                    dateFormat="dd.MM.yyyy"
                />
                <DatePicker
                    selected={date}
                    onChange={handleChangeDate}
                    showTimeSelect
                    showTimeSelectOnly
                    timeCaption="Time"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    timeIntervals={1}
                />
                <Checkbox flexEnd name='sms' checked={values['sms']} label='SMS' onClick={handleChange} />
                <TextArea
                    label="Notatki:"
                    name='note'
                    placeholder="Wpisz notatkę..."
                    onChange={handleChange}
                    value={values.note}
                    error={errors.note}
                />
            </FormBody>
            <FormFooter noMargin>
                <Buttons>
                    <Button
                        type='button'
                        onClick={onClickCancel}
                        width="50%"
                    >
                        {/* {translation && translation.buttons.cancel} */}
                        Cofnij zmiany
                    </Button>
                    <Button
                        type='submit'
                        width="50%"
                        green
                    >
                        {/* {translation && translation.buttons.cancel} */}
                        Dodaj zmiany
                    </Button>
                </Buttons>
            </FormFooter>
        </Form>
    )
};

export default FormAddEventRemind;
